import React from 'react';
import { Box, Grid, IconButton, Typography, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/styles';
import { Link } from 'react-scroll';
import { motion } from "framer-motion";


const useStyles = makeStyles((theme) => ({
    section: {
        height: '100vh',
        padding: '4em',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        paddingLeft: '10em',
    },
    logos: {
        height: '4em',
    },
    dummys: {
        height: '100vh'
    }
}));

const bounceTransition = {
    y: {
        duration: 1,
        yoyo: 3,
        ease: "easeIn",
    },
    backgroundColor: {
        duration: 0,
        yoyo: 3,
        ease: "easeOut",
        repeatDelay: 1,
    },
};

const Down = (props) => <motion.div {...props}></motion.div>;

const ProductHeaderView = ({ title, description, image }) => {

    const classes = useStyles();
    const theme = useTheme();

    const matchesXS = useMediaQuery(theme.breakpoints.up('xs'));
    const matchesSM = useMediaQuery(theme.breakpoints.up('sm'));
    const matchesMD = useMediaQuery(theme.breakpoints.up('md'));
    const matchesLG = useMediaQuery(theme.breakpoints.up('lg'));
    const matchesXL = useMediaQuery(theme.breakpoints.up('xl'));

    const titleVariant = matchesXL ? 'h1' : matchesLG ? 'h2' : matchesMD ? 'h3' : matchesSM ? 'h4' : matchesXS ? 'h5' : 'h6';
    const textVariant = matchesXL ? 'h3' : matchesLG ? 'h4' : matchesMD ? 'h5' : matchesSM ? 'h6' : matchesXS ? 'body1' : 'body1';


    return (
        <Grid container direction="column" className={classes.section} style={{ backgroundImage: `url(${image})` }}>

            <Grid item style={{ height: '8em' }}></Grid>

            <Grid item>
                <Grid container direction="column" >
                    <Grid item xs >
                        <Typography variant={titleVariant} align="center">
                            <Box fontWeight={900} lineHeight={2} letterSpacing={2} color={theme.palette.arenco.darkBlue} align="left">
                                {title}
                            </Box>
                        </Typography>
                    </Grid>
                    <Grid item xs={6} >
                        <Typography variant={textVariant} >
                            <Box fontWeight={500} lineHeight={1.5} color={theme.palette.arenco.darkBlue} align="left">
                                {description}
                            </Box>
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs container direction="column" justify="center">
                <Grid item container alignItems="flex-end">
                    <Grid item xs={4} align="center">

                    </Grid>
                    <Grid item xs={4} align="center">
                        <Down transition={bounceTransition}
                            animate={{ y: ["0em", "4em"], }}>
                            <Link style={{
                                cursor: 'pointer',
                            }} to="about" spy={true} smooth={true} offset={0} duration={1000} delay={300}>
                                <IconButton
                                    color="primary"
                                    disableFocusRipple
                                    disableRipple>
                                </IconButton>
                            </Link>
                        </Down>
                    </Grid>
                </Grid>
            </Grid>
        </Grid >
    );
};

export default ProductHeaderView;